import { InventoryTransferDetailPrintModel } from "./inventory-transfer-detail-print.model";

export class InventoryTransferPrintModel {
  inventoryTransferId: number = 0;
  companyName: string = '';
  inventoryName: string = '';
  consecutive: string = '';
  branchOutputName: string = '';
  storeOutputName: string = '';
  branchEntryName: string = '';
  storeEntryName: string = '';
  dateOutput: Date = new Date();
  dateEntry: Date = new Date();
  observation: string = '';
  transporterName: string = '';
  transportValue: number = 0;
  inventoryTransferDetails: InventoryTransferDetailPrintModel[] = [];
}